<script lang="ts">
  import type { Job } from '$lib/careers/types';
  import debounce from 'lodash/debounce';
  import { TwistGrid, TwistGridItem } from '@twist/core';

  export let job: Job;
  export let showApplyForm = false;
  export let isLoadingForm: boolean;
  let isNewBoard = false;

  let grnhseForm:
    | { [key: string]: unknown; htmlElement?: HTMLElement; iframeElement?: HTMLIFrameElement }
    | undefined = undefined;

  $: if (showApplyForm && Grnhse && !grnhseForm) {
    isLoadingForm = true;
    Grnhse.Settings.scrollOnLoad = false;
    grnhseForm = Grnhse.Iframe.load(job.id);

    if (grnhseForm) {
      if (grnhseForm.htmlElement) {
        // Old Greenhouse Job Board
        grnhseForm.htmlElement.onload = () => {
          isLoadingForm = false;
        };
      } else if (grnhseForm.iframeElement) {
        // New Greenhouse Job Board
        grnhseForm.iframeElement.onload = () => {
          isLoadingForm = false;
        };

        isNewBoard = true;
      }
    }
  }

  // Greenhouse iframe resizing isn't reliable and
  // leaves a lot of whitespace at the bottom.
  // This is a workaround to resize the iframe.
  const _handleResize = () => {
    if (isNewBoard) return;

    const iframe = document.getElementById('grnhse_iframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.setAttribute('height', 'auto');
    }
  };

  const handleResize = debounce(_handleResize, 150);
</script>

<svelte:window on:resize={handleResize} />

<TwistGrid>
  <TwistGridItem
    colSpan={{ min: 4, lg: isNewBoard ? 7 : 12 }}
    colStart={{ min: 1, lg: isNewBoard ? 5 : 1 }}
  >
    <div id="grnhse_app" />
  </TwistGridItem>
</TwistGrid>
